import { useEffect, useState } from 'react';
import { resolveWorkshopLeaderOffer } from '@/utils/workshopLeaderOffer';

/**
 * Starts unresolved so the prerendered $200 markup can stay in the HTML without
 * flashing the offer price. The effect reads the URL and sessionStorage together.
 */
export function useWorkshopLeaderOffer(search: string): { isOffer: boolean; resolved: boolean } {
  const [isOffer, setIsOffer] = useState(false);
  const [resolved, setResolved] = useState(false);

  useEffect(() => {
    setIsOffer(resolveWorkshopLeaderOffer(search, window.sessionStorage));
    setResolved(true);
  }, [search]);

  return { isOffer, resolved };
}
